import { BET_RESULT_STATUS } from '../../../constants';

const normalizePayBlockElements = (elements = []) =>
  elements.map((element) => {
    return {
      ...element,
      carditemResult: BET_RESULT_STATUS.BLOCKED,
      carditemResultText: BET_RESULT_STATUS.BLOCKED
    };
  });

const normalizeBetItem = (betItem) => {
  const isPayBlock = Boolean(betItem?.payBlock);

  return {
    ...betItem,
    ...(isPayBlock
      ? {
          cardResult: BET_RESULT_STATUS.BLOCKED,
          cardResultText: BET_RESULT_STATUS.BLOCKED,
          cardSumWin: '0.00',
          elements: normalizePayBlockElements(betItem.elements)
        }
      : {})
  };
};

export default normalizeBetItem;
